//c
export enum CheckoutStep {
  SHIPPING_ADDRESS = 'SHIPPING_ADDRESS',
  SHIPPING_METHOD = 'SHIPPING_METHOD',
  PAYMENT = 'PAYMENT',
}

export interface TradePartnerItemType {
  firstname: string;
  lastname: string;
  companyname: string;
  entityid: string;
}
